/**
 * Events Cards: animation of bars when entering the section in the viewport (Intersection Observer)
 */
document.addEventListener('DOMContentLoaded', function () {
	const section = document.querySelector('.events-cards')
	if (!section) return

	const observer = new IntersectionObserver(
		entries => {
			entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('is-visible')
					// Optional: detach observer after one-time execution
					// observer.unobserve(entry.target)
				}
			})
		},
		{
			root: null,
			rootMargin: '0px',
			threshold: 0.2, // animation when ~20% of the section is visible (you can change it to 0.1–0.5)
		},
	)

	observer.observe(section)
})
